// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client'; // Import createRoot from react-dom/client
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom'; // Import BrowserRouter

// Create the root element with createRoot (React 18+)
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render your App wrapped in Router
root.render(
	<Router>
		<App />
	</Router>
);
